import { RadioButtonPassThrough } from "primeng/radiobutton";

export const RadioButtonTelekomPT: RadioButtonPassThrough = {
    icon: {
        class: "border-1 border-transparent"
    }
};
